import { canWrap, isObject } from "../../../utils/zone.utils";
import useDiscard, { discardProps } from "../../useDiscard";
import useDebouncing from "../../utils/useDebouncing";
import useWeakMap from "../../utils/useWeakMap";
import { storeCopySource } from "../chain/store/useStoreCopySource";
import { storePathByLayer } from "../chain/store/useStorePathByLayer";
import useQueryOriginalSourceByLayer, { storeOriginalSourceByLayer } from "../chain/store/useStoreOriginalSource";
import useChainCreator from "../chain/useChainCreator";
import useLayerChain from "../chain/useLayerChain";
import { useQueryOriginSource } from "../chain/useQueryOriginal";
import useOnLayerAfterSet, { emitLayer, emitLayerAfterSet, useOnAfterSetForwarder } from "../observable/useOnLayerAfterSet";
import useOnLayerSet from "../observable/useOnLayerSet";
import useLayerIdentity, { identityLayer, isLayer } from "../chain/validator/useLayerIdentity";
import useMarkParentLinking, { getParentLinking } from "../utils/useMarkParentLinking";
import { getRootProps, isRoot, linkRootToProps, useMarkRootProp } from "../chain/store/useStoreRoot";
import useOnOriginalSourceChanged from "../observable/useOnOriginalSourceChanged";
import { useMarkRootLayer } from "../chain/store/useStoreRootLayer";
import useLogStack from "../utils/useLogStack";


/**
 * @param {Array<any>} arr;
 * @returns { boolean}
 */
export const canWrapArray = (arr) => {

}

const caching = useWeakMap();

const onDiscardLayer = (layer) => {
    caching.delete(layer);
}

const getArrayWacherCaching = (layer, arraySource) => caching.has(layer) ? caching.get(layer).get(arraySource) : undefined;

const setArrayWatcherCaching = (layer, arraySource, data) => {
    if (!caching.has(layer)) {
        caching.set(layer, useWeakMap());
        useDiscard(layer, onDiscardLayer);
    }
    caching.get(layer).set(arraySource, data);
}

const doWrapArray = (propertyPath, parentLayer, arrSource, parentChainId) => {
    const existing = getArrayWacherCaching(parentLayer, arrSource);
    if (existing) {
        return existing;
    }

    if (arrSource == undefined) debugger;

    if (isLayer(arrSource)) {
        arrSource = useQueryOriginalSourceByLayer(arrSource);
    }
    if (arrSource == undefined) debugger
    let arrCopySource = new Array(arrSource.length);

    // const arrCopySource = new Array(arrSource.length);

    const discardPool = []

    const discard = () => {
        while (discardPool.length > 0) {
            discardPool.shift().call();
        }
    }

    const wrapChild = (target, i) => {
        if (canWrap(target)) {
            const pathCloned = propertyPath.clone();
            pathCloned.push(i + '');
            const { newLayer, discardChain, getChainId, getRootLayer, getOriginalSource } = useChainCreator(parentChainId);
            const [l1] = newLayer(target, pathCloned);

            useMarkRootProp(l1, parentLayer)
            useMarkParentLinking(l1, parentLayer)
            useLogStack("ARRAY MARK ROOT",target, parentLayer);
            useMarkRootLayer(l1, parentLayer)

            const root = getRootProps(parentLayer)
            if (root) {
                useDiscard(root, discardChain)
                useMarkRootProp(l1, root)
            }
            if (getParentLinking(target) === parentLayer || isRoot(parentLayer)) {
                /** False when "target" is layer that is child of another layer. So current cannot destroy */
                useDiscard(parentLayer, discardChain)
                discardPool.push(discardChain);
            }
            return l1;
        } else {
            arrCopySource[i] = target
            return target;
        }
    }

    const notifyArrayChanges = useDebouncing(() => {
        const targetKey = propertyPath.last();
        parentLayer[targetKey] = arrCopySource;
    })

    for (let i in arrSource) {
        const target = arrSource[i];
        arrCopySource[i] = wrapChild(target, i)
    }

    const { notifyLayerChanges } = useLayerChain(parentChainId);

    const arrayProxy1 = new Proxy(arrCopySource, {
        set(target, index, value) {
            const origin = useQueryOriginSource(arrayProxy1);
            if (origin) {
                // debugger
                // Reflect.set(origin, index, value)
            }
            const old = target[index];
            if (index === 'length' && value < target.length) {
                /* Spliced Item */
                notifyArrayChanges();
            } else if (index >= arrCopySource.length && canWrap(value)) {
                // Push new Item
                value = wrapChild(value, index);
                arguments[2] = value;
                notifyArrayChanges();
                // console.log(propertyPath, layer1);
            } else if (typeof value === 'object' && isLayer(old) && !isLayer(value)) {
                Object.assign(old, value)
                value = old;
                arguments[2] = value;
            }
            return Reflect.set(...arguments);
        },
        get(target, index) {
            return Reflect.get(...arguments);
        }
    })

    identityLayer(arrayProxy1, 'array');
    if (!isLayer(arrSource)) {
        storeOriginalSourceByLayer(arrayProxy1, arrSource);
    }

    storeCopySource(arrayProxy1, arrCopySource)

    storePathByLayer(arrayProxy1, propertyPath);
    

    setArrayWatcherCaching(parentLayer, arrSource, { layer: arrayProxy1, discard });

    return getArrayWacherCaching(parentLayer, arrSource);
}


/**
 * @param {Array<any>} arr;
 */
const useArrayWatcher = (propertyPath, parentlayer, arrSource, chainId) => {
    const absPath = propertyPath.pathToString();
    let doDiscard;
    const { layer, discard } = doWrapArray(propertyPath, parentlayer, arrSource, chainId);
    doDiscard = discard;
    useOnLayerSet(parentlayer, (paths, absKey, key, newValue, oldValue) => {
        if (absPath !== absKey) return newValue;
        if (!Array.isArray(newValue)) return newValue;
        const old = useQueryOriginalSourceByLayer(parentlayer);
        // let originArray = newValue;
        if (isLayer(newValue)) {
            newValue = useQueryOriginalSourceByLayer(newValue);
        }
        if (Array.isArray(newValue)) {
            const output = doWrapArray(propertyPath, parentlayer, newValue, chainId);
            doDiscard = output.discard;
            newValue = output.layer;
        }

        return newValue;
    })
    return layer
}

export default useArrayWatcher;